import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useAppBrandKitContext } from '@/context/AppBrandKitContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'
import { ComponentSettingKey } from '@/shared/builder'

import { CompLocationMultiWrapperCore } from '../core/location-multi/wrapper'
import { CompLocationMulti } from './CompLocationMulti'

/**
 * CompLocationMultiWrapper
 */
const CompLocationMultiWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer }

  // brandkit
  const [themeState] = useBuilderColorSchemeV2()
  const { themes, currentTheme } = useAppBrandKitContext()
  const brandkitProps = { themes, currentTheme, mode: themeState.current }

  // tableData
  const { dbClient, tablesMap } = useDbClientContext()
  const tableId = compContext.settings?.[ComponentSettingKey.MultiLocationDataSource]
  const table = tableId ? tablesMap.get(tableId) : undefined

  if (!table || !dbClient) {
    return <div className='flex justify-center items-center py-8'>Loading...</div>
  }

  return (
    <CompLocationMultiWrapperCore
      infos={infosProps}
      brandkit={brandkitProps}
      tableData={{ dbTable: table, dbClient, tableId }}
    >
      {(props) => <CompLocationMulti {...props} />}
    </CompLocationMultiWrapperCore>
  )
}

export default CompLocationMultiWrapper
